"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonMenu = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var popover_1 = require("../../hooks/popover");
var portal_1 = require("../../hooks/portal");
var box_1 = require("../box");
var button_1 = require("../button");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var menu_1 = require("../menu");
var padding_1 = require("../padding");
var popover_animation_1 = require("../popover-animation");
var spacing_1 = require("../spacing");
var tether_1 = require("../tether");
function ButtonMenu(_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, items = _a.items, width = _a.width, style = _a.style;
    var _c = (0, popover_1.usePopover)({
        excludeTarget: true,
    }), popoverRef = _c.popoverRef, isPopoverOpen = _c.isPopoverOpen, togglePopover = _c.togglePopover, targetRef = _c.targetRef;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(button_1.Button, { type: "button", size: variant, elementRef: targetRef, onClick: togglePopover, minWidth: width, style: style },
            react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center", alignItems: "center" },
                children,
                react_1.default.createElement(spacing_1.Spacing, { width: 4 }),
                react_1.default.createElement(icons_1.IconCaret, { color: "currentColor" }))),
        react_1.default.createElement(portal_1.Portal, { name: "popover" },
            react_1.default.createElement(tether_1.Tether, { targetRef: targetRef, targetAnchor: "topLeft", anchor: "topLeft", yOffset: 43 },
                react_1.default.createElement(popover_animation_1.PopoverAnimation, { isOpen: isPopoverOpen, direction: "down" },
                    react_1.default.createElement(box_1.Box, { border: 1, borderRadius: 3, elementRef: popoverRef, boxShadow: "overlay", backgroundColor: "#fff" },
                        react_1.default.createElement(padding_1.Padding, { y: 8 },
                            react_1.default.createElement(menu_1.Menu, { items: items, onToggle: togglePopover }))))))));
}
exports.ButtonMenu = ButtonMenu;
//# sourceMappingURL=index.js.map